// Temporary permissions utility - to be replaced with proper permission checking later
import { config } from './config';
import { applications, roles } from './variables';

export const PERMISSIONS = {
  // Newsfeed permissions
  NEWSFEED_EDIT: true,
  NEWSFEED_DELETE: true,
  NEWSFEED_CREATE: true,

  // General permissions
  ADMIN_ACCESS: true,
  USER_MANAGEMENT: true,

  // Chapter permissions
  CHAPTER_MANAGEMENT: true,
  CHAPTER_EDIT: true,

  // Member permissions
  MEMBER_MANAGEMENT: true,
  MEMBER_EDIT: true,
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;

export const hasPermission = (permission: PermissionKey): boolean => {
  return PERMISSIONS[permission];
};

export const checkMultiplePermissions = (
  permissions: PermissionKey[]
): boolean => {
  return permissions.every((permission) => PERMISSIONS[permission]);
};

export const canViewTransferRequests = (): boolean => {
  // Can be a role or an app
  // TODO: need to not do this once we have a proper permissions system
  // let temp = 1;
  // if (1 === temp) return false;
  if (config.SEEKING_TRANSFER_ENABLED === false) return false;
  let role = localStorage.getItem('role');
  let apps = localStorage.getItem('apps');
  if (!apps && !role) return false;
  let allow = false;
  if (apps) allow = apps.includes(applications.SeekingTransferAdmin);
  if (allow) return true;
  let rolesAccepted = [
    roles.Admin,
    roles.Support,
    roles.Executive,
    roles.SPDOfficer,
    roles.RMR,
    roles.LCOfficer,
  ];
  return rolesAccepted.includes(role);
};
